module.exports = __webpack_public_path__ + "static/media/Finnovex-North-Africa-2024.6fcee912.png";